import React from 'react';
import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
  },
  cardContent: {
    textAlign: 'center',
    overflowWrap: 'break-word',
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 1),
      '&:last-child': {
        paddingBottom: theme.spacing(1.5),
      },
    },
  },
  word: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1rem',
    },
  },
}));

function RhymeCard({ rhyme, wide }) {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Typography variant={wide ? 'body1' : 'h6'} component="span" className={wide ? undefined : classes.word}>
          {rhyme}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default RhymeCard;
